// sample_chips.ts — onboarding 2-step pick_topic preset chips.
//
// Spec: docs/contracts/aha/state_machines/onboarding.yaml § pick_topic.
// 3 chips spanning 3 intent_preset values so the smart-default amplification
// (P5 me.last_intent_preset → preselect chip) has matching content for every
// returning user style.

export interface SampleChip {
  chip_id: 'converge_saas' | 'diverge_direction' | 'diagnose_bug';
  category_id: string;
  intent_preset: 'converge' | 'diverge' | 'diagnose';
  i18n_key: string; // onboarding.chip.{chipId}
  topic_template: string; // longer text used for actual session creation
}

export const SAMPLE_CHIPS: SampleChip[] = [
  {
    chip_id: 'converge_saas',
    category_id: 'first_run',
    intent_preset: 'converge',
    i18n_key: 'onboarding.chip.convergeSaas',
    topic_template:
      'I want to launch a SaaS for SMBs in the next 12 months. I have a list of 4-5 candidate niches and need the council to converge on the single most defensible option given my unfair distribution advantage with CN indie hacker community. Help me pick the highest-ROI direction.',
  },
  {
    chip_id: 'diverge_direction',
    category_id: 'first_run',
    intent_preset: 'diverge',
    i18n_key: 'onboarding.chip.divergeDirection',
    topic_template:
      'I am stuck. I have 12 months of runway, full-stack skills, and no clear direction. The council should diverge widely from "what could a solo dev profitably build" — surface 3-5 unconventional candidates I have not yet considered, including ones I might dismiss at first glance. Then critique each.',
  },
  {
    chip_id: 'diagnose_bug',
    category_id: 'first_run',
    intent_preset: 'diagnose',
    i18n_key: 'onboarding.chip.diagnoseBug',
    topic_template:
      'My SaaS landing page conversion dropped from 3.2% to 0.8% over the last 30 days. Nothing obvious changed in copy or pricing. The council should diagnose root cause: surface 3-5 hypotheses ranked by likelihood, then propose the cheapest validation step for the top 2.',
  },
];

export function chipById(id: string): SampleChip | undefined {
  return SAMPLE_CHIPS.find((c) => c.chip_id === id);
}

export function chipForIntentPreset(
  intent: string | undefined,
): SampleChip | undefined {
  if (!intent) return undefined;
  return SAMPLE_CHIPS.find((c) => c.intent_preset === intent);
}
